// Template file that will be recreated in this directly as build-params.ts with the variables set
// based on the build parameters. (e.g --sport=flowrestling)
export const buildParams: any = {
    sport: 'dynamic',
};
